export async function triggerDownload(url: string, filename: string) {
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to download file (${res.status}).`);
  }
  const blob = await res.blob();
  triggerDownloadBlob(blob, filename);
}

export function triggerDownloadBlob(blob: Blob, filename: string) {
  const blobUrl = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = blobUrl;
  link.download = filename;

  document.body.appendChild(link);
  link.click();
  link.remove();

  URL.revokeObjectURL(blobUrl);
}
